import { VideoPlayer } from "./VideoPlayer";
import { Link } from "react-router-dom";
import { Play, X, Share2, Link2 } from "lucide-react";
import { toast } from "sonner";
import { useSite } from "../../lib/site";
import { href, fmtDate } from "../../lib/i18n";
import { Img } from "./Common";

// Inline brand SVGs so every network has its own recognizable mark instead of
// a generic `@` fallback. Each component accepts a size prop and inherits the
// current text color (so hover styling tints them exactly like lucide icons).
const BrandX = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2H21.5l-7.09 8.106L22.75 22H16.17l-5.146-6.73L5.17 22H1.912l7.584-8.671L1.5 2h6.747l4.65 6.147Zm-1.144 18h1.82L7.0 4H5.08l12.02 16Z"/></svg>
);
const BrandFacebook = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.51 1.49-3.9 3.78-3.9 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.45 2.9h-2.33v6.99A10 10 0 0 0 22 12Z"/></svg>
);
const BrandWhatsApp = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 0 1 8.413 3.488 11.82 11.82 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24ZM6.597 20.13c1.676.995 3.276 1.591 5.44 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.513 5.266l.242.384-1.001 3.645 3.737-.994.95.0ZM17.472 14.382c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.767.967-.94 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.173.198-.298.297-.496.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.371-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.871.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413Z"/></svg>
);
const BrandLinkedIn = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.063 2.063 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
);
const BrandInstagram = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.2c3.2 0 3.584.012 4.85.07 1.17.054 1.805.249 2.227.413.56.218.96.478 1.38.898.42.42.68.82.898 1.38.164.422.36 1.057.413 2.227.058 1.265.07 1.645.07 4.85s-.012 3.584-.07 4.85c-.054 1.17-.249 1.805-.413 2.227-.218.56-.478.96-.898 1.38-.42.42-.82.68-1.38.898-.422.164-1.057.36-2.227.413-1.266.058-1.645.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.805-.249-2.227-.413-.56-.218-.96-.478-1.38-.898-.42-.42-.68-.82-.898-1.38-.164-.422-.36-1.057-.413-2.227C2.212 15.583 2.2 15.203 2.2 12s.012-3.585.07-4.85c.054-1.17.249-1.805.413-2.227.218-.56.478-.96.898-1.38.42-.42.82-.68 1.38-.898.422-.164 1.057-.36 2.227-.413C8.416 2.212 8.796 2.2 12 2.2zm0 1.8c-3.148 0-3.52.012-4.76.068-.983.045-1.517.21-1.873.348-.47.183-.806.401-1.16.754-.353.354-.571.69-.754 1.16-.138.356-.303.89-.348 1.873C3.012 8.48 3 8.852 3 12s.012 3.52.068 4.76c.045.983.21 1.517.348 1.873.183.47.401.806.754 1.16.354.353.69.571 1.16.754.356.138.89.303 1.873.348 1.24.056 1.612.068 4.76.068 3.148 0 3.52-.012 4.76-.068.983-.045 1.517-.21 1.873-.348.47-.183.806-.401 1.16-.754.353-.354.571-.69.754-1.16.138-.356.303-.89.348-1.873.056-1.24.068-1.612.068-4.76 0-3.148-.012-3.52-.068-4.76-.045-.983-.21-1.517-.348-1.873-.183-.47-.401-.806-.754-1.16-.354-.353-.69-.571-1.16-.754-.356-.138-.89-.303-1.873-.348C15.52 4.012 15.148 4 12 4zm0 2.869a5.131 5.131 0 1 1 0 10.262 5.131 5.131 0 0 1 0-10.262zm0 1.8a3.331 3.331 0 1 0 0 6.662 3.331 3.331 0 0 0 0-6.662zm5.338-2.03a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4z"/></svg>
);

export function NewsCard({ n, big }) {
  const { lang, t } = useSite();
  return (
    <Link to={href(lang, "news", n.slug)} data-testid={`news-card-${n.slug}`} className="group block">
      <div className={`overflow-hidden rounded-[var(--s-radius-sm)] bg-s-border aspect-[16/9]`}>
        <Img src={n.cover} alt={t(n.title)} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
      </div>
      <p className="mt-5 text-xs uppercase tracking-widest text-s-muted">{fmtDate(n.published_at, lang)}</p>
      <h3 className={`font-heading font-semibold mt-2 leading-snug group-hover:text-s-primary transition-colors ${big ? "text-2xl sm:text-3xl" : "text-xl"}`}>{t(n.title)}</h3>
      {big && <p className="mt-3 text-s-muted line-clamp-2">{t(n.summary)}</p>}
    </Link>
  );
}

export function AlbumCard({ a }) {
  const { lang, t, ui } = useSite();
  return (
    <Link to={href(lang, "album", a.slug)} data-testid={`album-card-${a.slug}`} className="group relative block overflow-hidden rounded-[var(--s-radius-sm)] aspect-[4/3]">
      <Img src={a.cover} alt={t(a.title)} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 p-6 text-white">
        <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest opacity-80"><Play size={12} fill="currentColor" /> {a.video_count ?? 0} {ui.videosCount}</span>
        <h3 className="font-heading text-2xl font-semibold mt-2">{t(a.title)}</h3>
      </div>
    </Link>
  );
}

export function VideoModal({ video, onClose }) {
  const { t } = useSite();
  if (!video) return null;
  return (
    <div className="fixed inset-0 z-[80] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="video-modal-player">
      <button onClick={onClose} className="absolute top-5 right-5 text-white p-2" aria-label="close" data-testid="video-modal-close"><X size={28} /></button>
      <div className="w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
        <div className="aspect-video rounded-xl overflow-hidden bg-black">
          <VideoPlayer v={video} title={t(video.title)} autoplay />
        </div>
        <p className="text-white mt-4 text-lg">{t(video.title)}</p>
      </div>
    </div>
  );
}

export function ShareButtons({ title, testid = "news-share-button", shareUrl, kind = "other", imageUrl = "" }) {
  const { ui } = useSite();
  const target = shareUrl || window.location.href;
  const url = encodeURIComponent(target);
  const text = encodeURIComponent(title);
  // Each row: [key, Icon, href, label, gradient classes, text color]
  const items = [
    ["x",        BrandX,        `https://twitter.com/intent/tweet?url=${url}&text=${text}`,         "X / Twitter", "bg-black hover:bg-neutral-800", "text-white"],
    ["facebook", BrandFacebook, `https://www.facebook.com/sharer/sharer.php?u=${url}`,              "Facebook",    "bg-gradient-to-br from-[#1877F2] to-[#0b5fd1] hover:brightness-110", "text-white"],
    ["instagram", BrandInstagram, "",                                                               "Instagram",   "bg-gradient-to-tr from-[#feda75] via-[#fa7e1e] via-40% to-[#d62976] hover:brightness-110", "text-white"],
    ["whatsapp", BrandWhatsApp, `https://wa.me/?text=${text}%20${url}`,                             "WhatsApp",    "bg-gradient-to-br from-[#25D366] to-[#128C7E] hover:brightness-110", "text-white"],
    ["linkedin", BrandLinkedIn, `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,       "LinkedIn",    "bg-gradient-to-br from-[#0A66C2] to-[#004182] hover:brightness-110", "text-white"],
  ];
  const track = (platform) => {
    try {
      const BACKEND = process.env.REACT_APP_BACKEND_URL;
      if (!BACKEND) return;
      const body = JSON.stringify({ platform, target, kind });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(`${BACKEND}/api/public/_track_share`, new Blob([body], { type: "application/json" }));
      } else {
        fetch(`${BACKEND}/api/public/_track_share`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
      }
    } catch { /* ignore */ }
  };
  const copy = () => {
    track("copy");
    navigator.clipboard?.writeText(target).then(() => toast.success("Link kopyalandı"));
  };

  // Native share (phone share sheet). Tries to attach image when available
  // so Instagram / stories receive the artwork; URL + title are shared too.
  const nativeShare = async (e) => {
    e?.preventDefault?.();
    track("native");
    const data = { title, text: title, url: target };
    try {
      if (imageUrl && navigator.canShare) {
        try {
          const res = await fetch(imageUrl, { mode: "cors" });
          if (res.ok) {
            const blob = await res.blob();
            const file = new File([blob], "share.jpg", { type: blob.type || "image/jpeg" });
            const withFile = { ...data, files: [file] };
            if (navigator.canShare(withFile)) {
              await navigator.share(withFile);
              return;
            }
          }
        } catch { /* fall through to text share */ }
      }
      if (navigator.share) {
        await navigator.share(data);
      } else {
        copy();
        toast.info("Cihazın paylaşım menüsü yok, link kopyalandı");
      }
    } catch (err) {
      // User cancelled or share failed silently; nothing to toast about.
      if (err?.name && err.name !== "AbortError") toast.error("Paylaşılamadı");
    }
  };

  // Instagram has no public web-share URL; on mobile the native sheet lets
  // the user pick Instagram and attach the story image, on desktop we open
  // the user's Instagram inbox so they can paste the link manually.
  const openInstagram = (e) => {
    e.preventDefault();
    track("instagram");
    if (navigator.share) { nativeShare(); return; }
    window.open("https://www.instagram.com/", "_blank", "noopener");
    navigator.clipboard?.writeText(target).then(() => toast.info("Link kopyalandı — Instagram'a yapıştırabilirsiniz"));
  };

  const hasNative = typeof navigator !== "undefined" && typeof navigator.share === "function";

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={testid}>
      <span className="flex items-center gap-2 text-sm text-amber-700/80 mr-2"><Share2 size={15} /> {ui.share}</span>

      {hasNative && (
        <button
          onClick={nativeShare}
          data-testid="share-native"
          aria-label="Cihazdan paylaş"
          title="Cihazdan paylaş (Instagram, Hikayeler, WhatsApp…)"
          className="h-10 px-3.5 rounded-full bg-gradient-to-r from-rose-500 via-fuchsia-500 to-indigo-500 text-white shadow-md hover:shadow-lg hover:brightness-110 transition flex items-center gap-2 text-sm font-semibold"
        >
          <Share2 size={15} /> Paylaş
        </button>
      )}

      {items.map(([k, Icon, u, label, bg, fg]) => {
        const onClick = k === "instagram" ? openInstagram : () => track(k);
        const href = k === "instagram" ? "#" : u;
        return (
          <a
            key={k}
            href={href}
            target={k === "instagram" ? undefined : "_blank"}
            rel="noopener noreferrer"
            onClick={onClick}
            data-testid={`share-${k}`}
            aria-label={label}
            title={label}
            className={`w-10 h-10 rounded-full ${bg} ${fg} shadow-sm hover:shadow-md flex items-center justify-center transition`}
          >
            <Icon size={16} />
          </a>
        );
      })}
      <button
        onClick={copy}
        data-testid="share-copy"
        aria-label="Linki kopyala"
        title="Linki kopyala"
        className="w-10 h-10 rounded-full border border-amber-200 bg-amber-50 text-amber-700 flex items-center justify-center hover:bg-s-primary hover:text-s-onprimary hover:border-s-primary transition-colors"
      >
        <Link2 size={16} />
      </button>
    </div>
  );
}
